<!--
  preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's
  center. The center of the circle will remain at the center of the mat-progress-spinner
  element containing the SVG.
-->
<!--
  All children need to be hidden for screen readers in order to support ChromeVox.
  More context in the issue: https://github.com/angular/components/issues/22165.
-->
<svg
  [style.width.px]="diameter"
  [style.height.px]="diameter"
  [attr.viewBox]="_getViewBox()"
  preserveAspectRatio="xMidYMid meet"
  focusable="false"
  [ngSwitch]="mode === 'indeterminate'"
  aria-hidden="true"
  #svg>

  <!--
    Technically we can reuse the same `circle` element, however Safari has an issue that breaks
    the SVG rendering in determinate mode, after switching between indeterminate and determinate.
    Using a different element avoids the issue. An alternative to this is adding `display: none`
    for a split second and then removing it when switching between modes, but it's hard to know
    for how long to hide the element and it can cause the UI to blink.
  -->
  <circle
    *ngSwitchCase="true"
    cx="50%"
    cy="50%"
    [attr.r]="_getCircleRadius()"
    [style.animation-name]="'mat-progress-spinner-stroke-rotate-' + _spinnerAnimationLabel"
    [style.stroke-dashoffset.px]="_getStrokeDashOffset()"
    [style.stroke-dasharray.px]="_getStrokeCircumference()"
    [style.stroke-width.%]="_getCircleStrokeWidth()"
    [style.transform-origin]="_getCircleTransformOrigin(svg)"></circle>

  <circle
    *ngSwitchCase="false"
    cx="50%"
    cy="50%"
    [attr.r]="_getCircleRadius()"
    [style.stroke-dashoffset.px]="_getStrokeDashOffset()"
    [style.stroke-dasharray.px]="_getStrokeCircumference()"
    [style.stroke-width.%]="_getCircleStrokeWidth()"
    [style.transform-origin]="_getCircleTransformOrigin(svg)"></circle>
</svg>
